<template>
  <div v-if="objDTO !== null">

    <div class="container">
      <div class="white-frame" v-if="stage == 1">
        <div class="title-text mb-3">
          <b>Dados do Sinistro</b>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="sinistroData">Data Sinistro</label>
            <Calendar
              id="sinistroData"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              disabled
              class="form-control p-0"
            />
          </div>
          <!-- <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroData.$invalid,
            }"
          >
            <label class="form-label" for="sinistroHora">Hora Sinistro</label>
            <Calendar
              id="sinistroHora"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              :timeOnly="true"
              hourFormat="24"
              :showSeconds="false"
              :manualInput="false"
              class="form-control p-0"
            />
          </div>-->

          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.TerceiroContacto.Nome.$invalid,
            }"
          >
            <label for="nome" class="form-label">Segurado Sinistrado</label>
            <InputText
              id="sinistrado"
              class="form-control"
              v-model="objDTO.Sinistro.TerceiroContacto.Nome"
            />
          </div>

          <div
            class="col-md-12"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroDescricao.$invalid,
            }"
          >
            <label class="form-label" for="sinistroDesc">Descrição Ocorrência</label>
            <Textarea
              id="sinistroDesc"
              v-model="objDTO.Sinistro.SinistroDescricao"
              :autoResize="true"
              rows="5"
              cols="30"
              class="form-control"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required':
                $v.objDTO.Sinistro.BoletimOcorrencia.BoletimOcorrenciaOpcaoId
                  .$invalid,
            }"
          >
            <label class="form-label" for="boletimOcorrencia">BO</label>
            <Dropdown
              id="boletimOcorrencia"
              placeholder="Selecione"
              v-model="
                objDTO.Sinistro.BoletimOcorrencia.BoletimOcorrenciaOpcaoId
              "
              :options="optionYN"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.BombeirosOpcaoId.$invalid,
            }"
          >
            <label class="form-label" for="bombeiros">Corpo de bombeiro acionado</label>
            <Dropdown
              id="bombeiros"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.BombeirosOpcaoId"
              :options="optionYN"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>
          <loading-state v-if="loading.coverages" />
        </div>

        <div v-if="!loading.coverages" class="row g-3">
          <div
            class="col-md-6"
            v-if="riskUnits.length > 1"
            :class="{
              'field-required':
                $v.objDTO.Apolice.UnidadeDeRiscoExternalId.$invalid,
            }"
          >
            <label class="form-label" for="riskUnit">Unidade de Risco</label>
            <Dropdown
              id="riskUnit"
              placeholder="Selecione"
              v-model="objDTO.Apolice.UnidadeDeRiscoExternalId"
              :options="riskUnits"
              optionLabel="Description"
              optionValue="RiskUnitId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="insuranceObjects.length > 1"
            :class="{
              'field-required':
                $v.objDTO.Apolice.ObjectoSeguradoExternalId.$invalid,
            }"
          >
            <label class="form-label" for="insuranceObject">Objeto Segurado</label>
            <Dropdown
              id="insuranceObject"
              placeholder="Selecione"
              v-model="objDTO.Apolice.ObjectoSeguradoExternalId"
              :options="insuranceObjects"
              optionLabel="Description"
              optionValue="InsuranceObjectId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Apolice.ApoliceCoberturaId.$invalid,
            }"
          >
            <label class="form-label" for="coverages">Cobertura</label>
            <Dropdown
              id="coverages"
              placeholder="Selecione"
              @change="changeCoverage"
              v-model="objDTO.Apolice.ApoliceCoberturaId"
              :options="coverages"
              optionLabel="Description"
              optionValue="GisCoverageId"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            v-if="coverages.length > 0"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroEventoId.$invalid,
            }"
          >
            <label class="form-label" for="evento">Evento</label>
            <Dropdown
              id="evento"
              placeholder="Selecione"
              v-model="objDTO.Sinistro.SinistroEventoId"
              :options="events"
              optionLabel="Description"
              optionValue="Id"
              class="form-control p-0"
            />
          </div>
        </div>

        <div class="col-12 Aligner aligner-right mt-4" v-if="!$v.objDTO.$invalid">
          <button class="button-base-small btn-green font-small mx-1" @click="stage = 2">Finalizar</button>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <div v-if="stage === 2">
      <div class="container">
        <!-- <div
            class="output-format d-xl-flex justify-content-xl-evenly  py-xl-3"
          >
        <resume-global :objDTO="objDTO" />-->
        <resume-vida :objDTO="objDTO" :events="events" :coverages="coverages" @back="back" />
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import {
  cpfCnpjValid,
  dateAfterToday,
  inputClean,
} from "../utils/customValidations";
import { getEvents, getOptions } from "../api/formMethods";
import { getInfoByOperationPK } from "../utils/helpers";
// import DadosComunicante from "../components/DadosComunicante.vue";
// import DadosSegurado from "../components/DadosSegurado.vue";
// import PesquisaApolice from "../components/PesquisaApolice.vue";
// import ResumeGlobal from "../components/ResumeGlobal.vue";
import ResumeVida from "../components/Resume/ResumeVida.vue";
import LoadingState from "../components/LoadingState.vue";

export default {
  components: {
    // DadosComunicante,
    // DadosSegurado,
    // PesquisaApolice,
    // ResumeGlobal,
    ResumeVida,
    LoadingState,
  },
  data() {
    return {
      stage: 1,
      objDTO: null,
      operationPK: null,
      gisRamoId: null,
      gisProdutoId: null,
      optionYN: [],
      showSinistro: false,
      loading: { coverages: false },
      insuranceObjects: [],
      riskUnits: [],
      coverages: [],
      events: [],
    };
  },
  validations: {
    objDTO: {
      Apolice: {
        ApoliceCoberturaId: { required },
      },
      ComunicanteContacto: {
        ParentescoId: {
          required,
        },
      },
      SeguradoContacto: {
        Nome: { required, inputClean },
        NrContribuinte: { required, cpfCnpjValid },
        DataNascimento: { required, dateAfterToday },
        nrID: { required, inputClean },
      },
      Sinistro: {
        SinistroData: { required, dateAfterToday },
        SinistroEventoId: { required },
        SinistroDescricao: { required, inputClean },
        BoletimOcorrencia: { BoletimOcorrenciaOpcaoId: { required } },
        BombeirosOpcaoId: { required },
        TerceiroContacto: {
          Nome: { required, inputClean },
        },
      },
    },
  },
  methods: {
    vinculoSegurado(contacto) {
      if (this.objDTO.ComunicanteContacto.ParentescoId == 1) {
        this.objDTO.SeguradoContacto.Nome = contacto.nome;
        this.objDTO.SeguradoContacto.NrContribuinte = contacto.cpf;
      } else {
        this.objDTO.SeguradoContacto.Nome = null;
        this.objDTO.SeguradoContacto.NrContribuinte = null;
      }
    },
    back(newStage) {
      this.stage = newStage;
    },
    async policySelected(operationPK) {
      if (operationPK) {
        this.operationPK = operationPK;
        this.showSinistro = true;

        try {
          this.loading.coverages = true;

          const {
            riskUnit,
            riskUnits,
            insuranceObject,
            insuranceObjects,
            coverage,
            coverages,
            events,
          } = await getInfoByOperationPK(
            operationPK,
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Sinistro.SinistroRamoId
          );

          this.objDTO.Apolice.UnidadeDeRiscoExternalId = riskUnit;
          this.objDTO.Apolice.ObjectoSeguradoExternalId = insuranceObject;
          this.objDTO.Apolice.ApoliceCoberturaId = coverage;
          this.riskUnits = riskUnits;
          this.events = events;
          this.insuranceObjects = insuranceObjects;
          this.coverages = coverages;
        } catch (error) {
          console.error(error);
        } finally {
          this.loading.coverages = false;
        }
      }
    },
    async changeCoverage() {
      this.events = await getEvents(
        this.objDTO.Apolice.ApoliceProdutoId,
        this.objDTO.Apolice.ApoliceCoberturaId,
        this.objDTO.Sinistro.SinistroRamoId
      );
    },
    async finishAviso() {
      this.stage = 2;
      //await createAviso(this.objDTO);
      // this.events = await getEvents(
      //   this.objDTO.Apolice.ApoliceProdutoId,
      //   this.objDTO.Apolice.ApoliceCoberturaId,
      //   this.objDTO.Sinistro.SinistroRamoId
      // );
    },
  },
  async mounted() {
    this.objDTO = this.$store.getters.getObjDTO;
    this.optionYN = await getOptions();
    await this.policySelected(this.objDTO.Apolice.ApoliceContrato);
    // this.objDTO = await getDTO();
    // this.objDTO.ProcessoOrigem
  },
  beforeDestroy() {
    // Limpar os campos preenchidos
    // const riskDesc = this.riskUnits.filter(x=> x.)
    // this.$store.commit('setApoliceInfo',);
    this.objDTO.Apolice.ApoliceNr = null;
    this.objDTO.Sinistro.TerceiroContacto.Nome = null;
    this.objDTO.Sinistro.SinistroDescricao = null;
    this.objDTO.Sinistro.BoletimOcorrencia.BoletimOcorrenciaOpcaoId = null;
    this.objDTO.Sinistro.BombeirosOpcaoId = null;
    this.objDTO.Apolice.UnidadeDeRiscoExternalId = null;
    this.objDTO.Apolice.ObjectoSeguradoExternalId = null;
    this.objDTO.Apolice.ApoliceCoberturaId = null;
    this.objDTO.Sinistro.SinistroEventoId = null;
  },
};
</script>
